import React, { useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";

import { getFeaturedRecipes } from "../../../store/actions";
import PlaceholderIMG from "../../../sharedComponents/placeholderImage";

const FeaturedRecipes = ({ getFeaturedRecipes, featuredRecipes, history, footer = null }) => {
	useEffect(() => {
		getFeaturedRecipes();
	}, [getFeaturedRecipes]);

	const getDetails = (item) => {
		history.push(`/nutrition/recipes/${item.id}/details`);
	};

	return (
		<div className="card card-primary w-100 h-100 m-0 p-4 border-0 featured-recipes-list">
			<h4 className="text-primary-dark">Featured Recipes</h4>
			<div className="pt-3 last-child-b-0">
				{featuredRecipes &&
					featuredRecipes.length > 0 &&
					featuredRecipes.map((item, index) => (
						<div
							className="d-flex mb-3 align-items-start border-bottom-default pb-3 pointer"
							key={index}
							onClick={() => getDetails(item)}>
							<PlaceholderIMG
								src={item.main_image && item.main_image.photo_s}
								width="80"
								height="60"
								bg="rgba(0,0,0,0.1)"
								color="rgba(0,0,0,0.3)"
								objectFit="cover"
							/>
							<div className="flex-fill ml-3">
								<h5>{item.name}</h5>
								<div className="row small lh-18">
									<div className="col-6">
										<div className="text-primary text-truncate">{item.get_range_calorie}</div>
										<div className="text-uppercase">calories</div>
									</div>
									<div className="col-6">
										<div className="m-0 text-primary text-truncate">{item.main_phase}</div>
										<div className="text-uppercase">phase</div>
									</div>
								</div>
							</div>
						</div>
					))}
			</div>
			{footer}
		</div>
	);
};

const mapDispatchToProps = { getFeaturedRecipes };

const mapStateToProps = (state) => {
	const { Recipes } = state;
	return {
		recipes: get(Recipes, "recipesResult.results", []),
		featuredRecipes: get(Recipes, "featuredRecipes")
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(FeaturedRecipes);
